// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lVtS","title":"styles_title__3-_-B"};